const LOCALES = { fr: 'fr-FR', en: 'en-US' };
/**
 * Formate un montant stocké en centimes (entier, jamais de flottant en base).
 * Deux décimales seulement si le montant n'est pas un nombre rond d'unités,
 * comme les listes de prix de la régie (Plex Mono, `tabular-nums`, 2.4).
 */
export function formatPrice(cents, lang = 'fr', currency = 'EUR') {
    const amount = cents / 100;
    const hasFraction = !Number.isInteger(amount) || cents % 100 !== 0;
    return new Intl.NumberFormat(LOCALES[lang], {
        style: 'currency',
        currency,
        minimumFractionDigits: hasFraction ? 2 : 0,
        maximumFractionDigits: hasFraction ? 2 : 0,
    }).format(amount);
}
//# sourceMappingURL=formatPrice.js.map